import { Link } from 'react-router-dom';
import { diagnosisConfig } from '../diagnosis/config';

export function HomePage() {
  return (
    <div className="page home-page">
      <section className="hero" aria-labelledby="home-title">
        <div className="hero-copy">
          <span className="eyebrow">1～3 分钟 · 自助定位</span>
          <h1 id="home-title">先把问题找准，<br />再决定下一步。</h1>
          <p>
            按你现在看到的页面一步步选择。能自己解决的直接处理；需要卖家核实的，会生成一段诊断摘要。
          </p>
        </div>
        <div className="diagnostic-seal" aria-label="隐私承诺">
          <span>不上传</span>
          <strong>账号 / 密码</strong>
          <small>所有选择只保留在当前浏览器</small>
        </div>
      </section>

      <section className="issue-section" aria-labelledby="issue-title">
        <div className="section-heading">
          <span className="eyebrow">从这里开始</span>
          <h2 id="issue-title">你现在遇到哪种情况？</h2>
        </div>
        <div className="issue-list">
          {diagnosisConfig.issues.map((issue) => (
            <Link className="issue-card" key={issue.id} to={`/diagnose/${issue.id}?restart=1`}>
              <span className="issue-marker">{issue.marker}</span>
              <span className="issue-copy">
                <strong>{issue.title}</strong>
                <small>{issue.summary}</small>
              </span>
              <span className="issue-arrow" aria-hidden="true">→</span>
            </Link>
          ))}
        </div>
      </section>

      <aside className="boundary-note">
        <strong>先说明一件事</strong>
        <p>
          会员兑换与 API、AI Studio、反重力等服务的资格和额度不是一回事。页面会先帮你分清是哪一类问题。
        </p>
        <Link to="/activate">查看激活帮助和完整教程</Link>
      </aside>
    </div>
  );
}
